import { Dialog, DialogTitle } from 'components/Dialog';
import { Box } from '@mui/material';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { useEffect, useId, useState } from 'react';
import { usePolls } from 'features/polls/usePolls';
import QuizFormContainer from 'features/quizzes/components/quiz-form/QuizFormContainer';
import { createQuizRequested } from 'features/quizzes/actions';
import type { CreateQuizData } from 'features/quizzes/types';

const CreateQuizModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const [quizData, setQuizData] = useState<CreateQuizData>({
    title: '',
    timeLimitSeconds: 0,
    timingMode: 'quiz',
    showCorrectAnswers: false,
    passingScorePercentage: undefined,
    questions: [],
  });

  const modalId = useId();
  const { isFeatureAvailable, canManagePolls } = usePolls();
  const modalShouldBeClosed = !isFeatureAvailable || !canManagePolls;

  useEffect(() => {
    if (modalShouldBeClosed) {
      dispatch(closeModal('createQuiz'));
    }
  }, [modalShouldBeClosed, dispatch]);

  const handleFormChange = (data: CreateQuizData) => {
    setQuizData(data);
  };

  const handleSubmit = (data: CreateQuizData) => {
    dispatch(
      createQuizRequested({
        title: data.title,
        timeLimitSeconds: data.timeLimitSeconds,
        timingMode: data.timingMode,
        showCorrectAnswers: data.showCorrectAnswers,
        passingScorePercentage: data.passingScorePercentage,
        questions: data.questions,
      })
    );
    dispatch(closeModal('createQuiz'));
  };

  const handleCancel = () => {
    dispatch(closeModal('createQuiz'));
  };

  return (
    <Dialog
      open={!modalShouldBeClosed}
      maxWidth="xs"
      fullWidth
      aria-labelledby={`${modalId}-title`}
      disableRestoreFocus
    >
      <DialogTitle id={`${modalId}-title`}>{t('quizzes.create_quiz.title')}</DialogTitle>
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <QuizFormContainer
          quizData={quizData}
          onChange={handleFormChange}
          onDialogClose={handleCancel}
          onDialogSubmit={handleSubmit}
        />
      </Box>
    </Dialog>
  );
};

export default CreateQuizModal;
